<template>
  <div id="default-layout" :class="layoutClass()">
    <div v-if="navbarLocation === 'side'" style="width: 50px;">
      <SideNavbar />
    </div>
    <TopNavbar v-else />
    <div class="main-content">
      <component :is="layout.name" v-if="currentPcs"/>
    </div>
    <ChatBubble v-if="bubble"/>
    <div class="container modal">
      <Modal />
    </div>
    <Websocket hidden />
  </div>
</template>

<script>
import TopNavbar from '~/components/Parks/TopPcsNavbar'
import SideNavbar from '~/components/PcsNavbar'
import ChatBubble from "../pages/modules/chat/bubbleChat"
import Modal from '~/components/modal'
import Websocket from '~/components/Websocket'
import Vue from 'vue'
import axios from 'axios'
import { mapActions, mapGetters, mapState } from 'vuex'


// This pulls in all the components from the current folder to allow them to be displayed
const componentContext = require.context('./', false, /(?!basepcs).*\.vue$/, 'lazy')

componentContext.keys().forEach((componentFilePath) => {
  const componentName = componentFilePath.split('/').pop().split('.')[0];
  Vue.component(componentName, () => componentContext(componentFilePath));
})

export default {
  name: 'BasePcsLayout',

  components: {
    TopNavbar,
    SideNavbar,
    ChatBubble,
    Modal,
    Websocket
  },

  data: function() {
    return {
      currentPcs: null,
      navbarLocation: null,
      layout: {
        name: null,
      }
    }
  },

  computed: {
    ...mapState({
      chat: state => state.chat.showChat,
      bubble: state => state.chat.bubble
    }),
    ...mapGetters({
      loadNavbar: 'navbar/visible',
      classId: 'auth/classId',
      group: 'group/group'
    })
  },

  provide() {
    return {
      layout: this.layout
    }
  },

  created: function() {
    let pcs = localStorage.getItem('pcs')
    let classId = JSON.parse(localStorage.getItem('userClass'))

    axios.post('/api/classes').then(response => {
      let classes = response.data
      let userClass = classes.find(classObj => {
        return classObj.class_id === classId
      })
      if (userClass) {
        this.setClassId(userClass.class_id)
      }
      else {
        this.$router.push({ name: 'home' })
      }
    })

    axios.post('/api/pcs_layout', {
      params: {
        pcs: pcs
      }
    })
    .then((response) => {
      this.layout.name = response.data
    })


    this.currentPcs = localStorage.getItem('theme')

    // import pcs specific stylesheet
    let file = document.createElement('link')
    file.rel = 'stylesheet'
    file.href = `${process.env.MIX_BASE_URL}/storage/css/modules/dashboard/${this.currentPcs}.css`
    file.type = 'text/css'
    document.head.appendChild(file)

    // Load PCS-specific color scheme
    axios.post('/api/pcs/load_color_scheme', {
      params: {
        pcs: pcs,
      },
    }).then(response => {
      let root = document.documentElement
      response.data.forEach(color => {
        let tag = '--' + color.tag
        let rgbTag = tag + '-rgb'
        let textTag = tag + '-bg-text'
        let inverseTextTag = tag + '-inverse-bg-text'
        let hoverTag = tag + '-hover'

        let rgb = this.hexToRgb(color.color);
        let rgbValue = rgb ? `${rgb[0]},${rgb[1]},${rgb[2]}` : null
        let textColors = rgb ? this.pickTextColor(rgb[0], rgb[1], rgb[2]) : null
        let hoverColor = rgb ? `${rgb[0] * 0.85}, ${rgb[1] * 0.85}, ${rgb[2] * 0.85}` : null

        root.style.setProperty(tag, color.color)
        root.style.setProperty(rgbTag, rgbValue)
        root.style.setProperty(textTag, textColors.text)
        root.style.setProperty(inverseTextTag, textColors.inverse)
        root.style.setProperty(hoverTag, hoverColor)
      })
    }),

    // Determine whether to use side or top navbar
    axios.post('/api/pcs/tabs', {
      params: {
        pcs: localStorage.getItem('pcs'),
      },
    })
    .then(response => {
      this.navbarLocation = response.data.settings.location
    })
  },

  beforeDestroy: async function() {
    // Leave channels when leaving page
    if (this.group.id) {
      Echo.leave('group.' + this.group.id)
      Echo.leave('group.chat.' + this.group.id)
    }
    // Clear module data
    this.clearState()
  },

  methods: {
    ...mapActions({
      setClassId: 'auth/setClassId',
      clearState: 'events/clearState',
    }),

    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      if (result) {
        let r = parseInt(result[1], 16)
        let g = parseInt(result[2], 16)
        let b = parseInt(result[3], 16)
        return [r, g, b]
      }
      return null
    },

    pickTextColor(r, g, b) {
      if (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) {
        return {
          text: "#000000",
          inverse: "#ffffff",
        }
      }
      else {
        return {
          text: "#ffffff",
          inverse: "#000000",
        }
      }
    },

    layoutClass() {
      if (this.navbarLocation == 'top') {
        return 'top-navbar-layout'
      } else {
        return 'side-navbar-layout'
      }
    },
  }
}
</script>
<style lang="scss" scoped>
#default-layout {
  display: flex;
  height: 100%;
  width: 100%;
}

.top-navbar-layout {
  flex-direction: column;
  .main-content {
    flex: 1;
  }
}
.side-navbar-layout {
  flex-direction: row;
  align-items: stretch;
}
.main-content {
  flex: 1;
}

.chatBubble{
  display: flex;
  position: absolute;
  top: 3px;
  bottom: 3px;
  right: 3px;
  left: 53px;
  z-index: 9;
}

</style>
